import React from 'react';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';

/**
 * The label Components for Question Options.
 */
export function Label(props) {
  return (
    <label className={props.className} htmlFor={props.id}>
      {parse(props.label)}
    </label>
  );
}

Label.propTypes = {
  /**
   * className to be set for label element
   */
  className: PropTypes.string,
  /**
   * Text to be displayed
   */
  label: PropTypes.string.isRequired,
};

Label.defaultProps = {
  className: '',
  label: '',
  id: 0,
};
